import { render, staticRenderFns } from "./RoundtableListAdmin.vue?vue&type=template&id=0513422b"
import script from "./RoundtableListAdmin.vue?vue&type=script&lang=js"
export * from "./RoundtableListAdmin.vue?vue&type=script&lang=js"
import style0 from "./RoundtableListAdmin.vue?vue&type=style&index=0&id=0513422b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports